class ChartValidation {
    constructor (validation) {
        this.errors = validation.errors
        this.warnings = validation.warnings
    }
}

module.exports = ChartValidation
